import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import styles from "./Footer.module.css"
import {sendRequest} from "../../common";

function Footer() {

	const navigate = useNavigate()

	const [configs, setConfigs] = useState([])

	const getConfigs = () => {
		sendRequest('common/config/?size=100', 'GET', null, data => {
			setConfigs(data)
		})
	}

	const getValue = (key) => {
		return configs.filter(item => item.key === key).pop()?.value
	}

	useEffect(() => {
		getConfigs()
	}, [])

	return (
		<>
			<div className={styles.quickWrap}>
				<div
					className={styles.quickBtn}
					onClick={() => {
						window.open('http://pf.kakao.com/_eRLrj/chat')
					}}>
					빠른 상담하기
				</div>
			</div>
			<div className={styles.footerWrap}>
				<div className={styles.titleWrap}>
					<div className={styles.title}>
						<h5>(주)인컬리지</h5>
						<div>
							<button type="button"
								onClick={() => {
									navigate("")
								}}>
								이용약관
							</button>
							<button type="button"
								onClick={() => {
									navigate("")
								}}>
								개인정보처리방침
							</button>
						</div>
					</div>
				</div>
				<p className={styles.info}>
					<span>{getValue('ADDRESS')}</span>
					<span>사업자 번호 : {getValue('REGISTRATION_NUMBER')} ㅣ통신판매업종신고 : {getValue('ONLINE_NUMBER')}</span>
					<span>대표번호 : {getValue('TEL')} ㅣ이메일 : {getValue('EMAIL')} ㅣ개인정보관리 책임자 : {getValue('PRIVACY_NAME')}</span>
					<span className={styles.copy}>COPYRIGHTⓒ HUMANCOLLEGE INC. ALL RIGHTS RESERVED</span>
				</p>
			</div>
		</>
	)
}

export default Footer
